import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { CTAButton } from './ui/CTAButton';
import { Shield, Star, Clock } from 'lucide-react';
export function OfferBlock() {
  return <AnimatedSection id="offer-block" className="bg-cream-dark/30 pb-24" data-id="element-134">
      <div className="max-w-5xl mx-auto" data-id="element-135">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-mint-light" data-id="element-136">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-137">
            {/* Image Side */}
            <div className="bg-mint-light/50 p-8 md:p-12 flex items-center justify-center relative" data-id="element-138">
              <div className="absolute top-4 left-4 flex gap-2" data-id="element-139">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-140" />)}
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/gAQTXyZ31dUDpJmM5dMYfj/El_Kit_de_Primeros_Auxilios_Emocionales.png" alt="El Kit de Primeros Auxilios Emocionales" className="w-full max-w-md drop-shadow-2xl rounded-xl transform hover:scale-105 transition-transform duration-500" data-id="element-141" />
            </div>

            {/* Content Side */}
            <div className="p-8 md:p-12 flex flex-col justify-center space-y-8" data-id="element-142">
              <div className="space-y-4" data-id="element-143">
                <h2 className="text-3xl md:text-4xl font-bold text-charcoal leading-tight" data-id="element-144">
                  Recupera el control de tu hogar y elimina la culpa nocturna
                </h2>
                <p className="text-xl text-charcoal-light italic" data-id="element-145">
                  ...por menos de lo que cuesta una pizza familiar.
                </p>
              </div>

              <div className="bg-cream p-6 rounded-2xl border border-gold/20 text-center space-y-2 relative overflow-hidden" data-id="element-146">
                <div className="absolute top-0 left-0 w-full h-1 bg-gold" data-id="element-147" />
                <p className="text-charcoal-light font-medium uppercase tracking-wider text-sm" data-id="element-148">
                  Precio Especial
                </p>
                <div className="flex items-center justify-center gap-2" data-id="element-149">
                  <span className="text-5xl font-bold text-charcoal" data-id="element-150">
                    $6.39
                  </span>
                  <span className="text-xl text-charcoal-light line-through" data-id="element-151">
                    $19
                  </span>
                </div>
                <p className="text-mint-dark font-medium flex items-center justify-center gap-2 pt-2" data-id="element-152">
                  <Clock className="w-4 h-4" data-id="element-153" /> Oferta por tiempo limitado
                </p>
              </div>

              <div className="pt-4" data-id="element-154">
                <CTAButton className="w-full" onClick={() => {
                if (window.fbq) {
                  window.fbq('track', 'AddToCart', {
                    content_name: 'El Kit de Primeros Auxilios Emocionales',
                    content_type: 'product',
                    value: 6.39,
                    currency: 'USD'
                  });
                }
                window.open('https://jacadigitalhub.com/cart/52166371574053:1', '_blank');
              }} data-id="element-155" />
              </div>

              <div className="flex items-center justify-center gap-2 text-sm text-charcoal-light pt-4 border-t border-gray-100" data-id="element-156">
                <Shield className="w-4 h-4 text-mint-dark" data-id="element-157" />
                <span data-id="element-158">Garantía de satisfacción de 7 días</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}